import StorageService from '@js/modules/storage';

const rideStoreMapModule = {
    _rideStoreModel: {
        storeKey: 'MapRideStore'
    },

    storeRide(linePoints) {
        if(!linePoints || linePoints.length === 0) {
            this._removeRidePoints();
        } else {
            const normalizedPoints = this._normalizedPoints(linePoints);

            this._saveRidePoints(normalizedPoints);
        }
    },

    getStoredRide() {
        return this._retrieveRidePoints();
    },

    /* Private Methods
    ******************** */
    _normalizedPoints(linePoints) {
        const points = [];

        for (let i = 0; i < linePoints.length; i++) {
            const thisLinePoint = linePoints[i];

            points.push({
                latitude: thisLinePoint.latLng.lat,
                longitude: thisLinePoint.latLng.lng,
                computed: thisLinePoint.computed,
                deltaDistance: thisLinePoint.deltaDistance,
                deltaTime: thisLinePoint.deltaTime,
                deltaPause: thisLinePoint.deltaPause,
                datetime: thisLinePoint.datetime,
                elevation: thisLinePoint.elevation,
                speed: thisLinePoint.speed,
                heartRate: thisLinePoint.heartRate
            });
        }

        return points;
    },

    _saveRidePoints(points) {
        return StorageService.setItem(this._rideStoreModel.storeKey, points);
    },

    _retrieveRidePoints() {
        return StorageService.getItem(this._rideStoreModel.storeKey);
    },

    _removeRidePoints() {
        return StorageService.removeItem(this._rideStoreModel.storeKey);
    }
};

export default rideStoreMapModule;
